export const StatementUploadStyles = {
  mainContainer: {
    width: '100%',
    padding: '40px 50px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: '300px',
    '@media (max-width:1400px)': {
      padding: '30px',
    },
    // '@media (min-width:1200px)': {
    //   maxHeight: '350px',
    // },
    '@media (max-width:1200px)': {
      maxHeight: '400px',
    },
  },
  mainContainerBundle: {
    width: '100%',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
  },
  text1: {
    font: 'normal 700 20px/normal Arial',
    color: '#000',
    display: 'flex',
    width: 'fit-content',
    position: 'relative',
    marginTop: '30px',
    marginBottom: '15px',
  },
  Bundletext1: {
    fontWeight: 700,
    marginTop: '24px',
    marginBottom: '13px',
    display: 'flex',
    width: 'fit-content',
    position: 'relative',
    // marginTop: '38px',
    // marginBottom: '10px',
    whiteSpace: 'nowrap',
  },
  text2: {
    font: 'normal 400 16px/normal Arial',
    color: '#444',
    marginBottom: '25px !important',
  },
  Bundletext2: {
    marign: '0px !important',
    '&.MuiButton-root.Mui-disabled': {
      marign: '0px !important',
    },
  },
  text3: {
    font: 'normal 400 12px/normal Arial',
    color: '#808285',
    marginTop: '10px',
  },
  uploadBtn: {
    padding: '14px 20px',
    borderRadius: '56px',
    font: 'normal 700 16px/20px Arial',
    color: '#661C69',
    textAlign: 'center',
    textTransform: 'none',
    border: '1.6px solid #661c69',
    '@media (min-width:1200px) and (max-width:1300px)': {
      padding: '9px',
    },
    '@media (max-width:1200px)': {
      width: '100%',
    },
    '&:focus': {
      outline: '2px solid #661C69',
      outlineOffset: '2px',
    },
  },
  uploadBtnBundle: {
    // padding: '14px 50px',
    maxWidth: '169px',
    width: '100%',
    height: '32px',
    // marginTop: '32px',
    whiteSpace: 'nowrap',
    borderRadius: '56px',
    font: 'normal 700 16px/20px Arial',

    textAlign: 'center',
    textTransform: 'none',
    '&:focus': {
      outline: '2px solid #661C69',
      outlineOffset: '2px',
    },
  },
  cameraBtn: {
    padding: '14px 20px',
    borderRadius: '56px',
    font: 'normal 700 16px/20px Arial',
    color: '#661C69',
    textAlign: 'center',
    textTransform: 'none',
    border: '1.6px solid #661c69',
    minWidth: '125px',
    '@media (min-width:1200px) and (max-width:1300px)': {
      padding: '9px',
    },
    '@media (max-width:1200px)': {
      width: '100%',
    },
    '&:focus': {
      outline: '2px solid #661C69',
      outlineOffset: '2px',
    },
  },
  btnContainer: {
    display: 'flex',
    gap: '15px',
    '@media (max-width:1200px)': {
      flexDirection: 'column',
    },
  },
  uploadDone: {
    display: 'flex',
    borderRadius: '6px',
    border: '1px solid #128A08',
    background: '#FFF',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    padding: '20px 0',
    marginTop: '5px',
  },
  uploadFail: {
    display: 'flex',
    borderRadius: '6px',
    border: '1px solid #E60808',
    background: '#FFF',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    padding: '20px 0',
    marginTop: '5px',
  },
  fileName: {
    font: 'normal 400 16px/16px Arial',
    color: '#444',
    overflowWrap: 'break-word',
    wordBreak: 'break-all',
    width: '100%',
  },
  uploadSuccessMssg: {
    font: 'normal 400 10px/16px Arial',
    color: '#128A08',
  },
  uploadFailMssg: {
    font: 'normal 400 10px/16px Arial',
    color: '#E60808',
  },
  disabledButton: {
    '&.MuiButton-root.Mui-disabled': {
      background: `#E4E9F2`,
      border: `#E4E9F2`,
      borderRadius: '56px',
      fontWeight: 700,
      color: 'rgba(143, 155, 179, 0.5)',
      width: '169px',
      height: '48px',
      font: 'normal normal bold 16px/18px Arial',
      letterSpacing: '1.01px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#E4E9F2',
      },
      '@media(max-width:600px)': {
        width: '169px',
        height: '48px',
      },
    },
  },
};
